import { render, staticRenderFns } from "./odemebilgileri.vue?vue&type=template&id=740c4fa8"
import script from "./odemebilgileri.vue?vue&type=script&lang=js"
export * from "./odemebilgileri.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports